var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_45",
    transform: "translate(-0.419 -0.419)",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_1",
    y2: 36,
    transform: "translate(20.419 2.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_136",
    d: "M129.341,38.333l-5.671,4.474L118,38.333",
    transform: "translate(-103.252 -32.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_137",
    d: "M129.341,262.477,123.671,258,118,262.477",
    transform: "translate(-103.252 -227.052)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_2",
    x1: 36,
    transform: "translate(2.419 20.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_138",
    d: "M261.479,129.341,257,123.671,261.479,118",
    transform: "translate(-226.17 -103.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_139",
    d: "M37.336,129.341l4.474-5.671L37.336,118",
    transform: "translate(-31.923 -103.252)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_3",
    x1: 15.766,
    y2: 15.766,
    transform: "translate(12.536 12.536)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_4",
    x1: 15.766,
    y1: 15.766,
    transform: "translate(12.536 12.536)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWinter);
export default __webpack_public_path__ + "static/media/icon-winter.c24a5e126ca4459212f05050a3fa1801.svg";
export { ForwardRef as ReactComponent };